import { fromJS } from 'immutable';
export var SET_USER_LIST = 'user-management/SET_USER_LIST';
export var SET_USER_SORT = 'user-management/SET_USER_SORT';
export var SET_ROLE_RIGHT_LIST = 'user-management/SET_ROLE_RIGHT_LIST';
export var SET_ROLE_RIGHT_SORT = 'user-management/SET_ROLE_RIGHT_SORT';
export var SET_ALL_ROLE_RIGHT_LIST = 'user-management/SET_ALL_ROLE_RIGHT_LIST';
export var SET_AUTHORIZATIONS = 'user_management/SET_AUTHORIZATIONS';
export var SET_DIALOG_INFO = 'user-management/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'user-management/CLEAR_DIALOG_INFO';
export var SET_KEYWORD = 'user-management/SET_USER_SEARCH_KEYWORD';
export var RESET = 'user/RESET';
export var setUserList = function setUserList(data) {
  return {
    type: SET_USER_LIST,
    data: data
  };
};
export var setUserSort = function setUserSort(sort) {
  return {
    type: SET_USER_SORT,
    sort: sort
  };
};
export var setRoleRightList = function setRoleRightList(data) {
  return {
    type: SET_ROLE_RIGHT_LIST,
    data: data
  };
};
export var setRoleRightSort = function setRoleRightSort(sort) {
  return {
    type: SET_ROLE_RIGHT_SORT,
    sort: sort
  };
};
export var setAllRoleRightList = function setAllRoleRightList(data) {
  return {
    type: SET_ALL_ROLE_RIGHT_LIST,
    data: data
  };
};
export var setAuthorizations = function setAuthorizations(data) {
  return {
    type: SET_AUTHORIZATIONS,
    data: data
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo() {
  return {
    type: CLEAR_DIALOG_INFO
  };
};
export var setKeyword = function setKeyword(data) {
  return {
    type: SET_KEYWORD,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialForm = {
  id: null,
  office: '',
  jobTitle: '',
  userName: '',
  displayName: '',
  password: '',
  repassword: '',
  sex: 0,
  mobilePhone: '',
  email: '',
  groups: [],
  authorizations: [],
  authorizationResources: [],
  groupAuthorizationResources: [],
  alarmLevels: [],
  area: null,
  authorizationResourcesType: [0],
  loginType: 0,
  isLocked: false,
  needChangePwd: false,
  lastLoginDate: '',
  lastChangePwdDate: '',
  totalElements: 1
};
var initDialogInfo = {
  // mode: user.create, user.edit, rights.create, rights.edit
  mode: '',
  data: {}
};
var initialState = fromJS({
  userLst: [],
  userSort: {
    field: 'username',
    desc: false
  },
  roleRightList: [],
  roleRightSort: {
    field: 'name',
    desc: false
  },
  allRoleRightList: [],
  authorizations: [],
  dialogInfo: initDialogInfo,
  keyword: '' // rightsList: []

});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_USER_LIST:
      return state.set('userList', fromJS(action.data));

    case SET_USER_SORT:
      return state.set('userSort', fromJS(action.sort));

    case SET_ROLE_RIGHT_LIST:
      return state.set('roleRightList', fromJS(action.data));

    case SET_ROLE_RIGHT_SORT:
      return state.set('roleRightSort', fromJS(action.sort));

    case SET_ALL_ROLE_RIGHT_LIST:
      return state.set('allRoleRightList', fromJS(action.data));

    case SET_AUTHORIZATIONS:
      return state.set('authorizations', fromJS(action.data));

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(action.data));

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(initDialogInfo));

    case SET_KEYWORD:
      return state.set('keyword', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}